import React from 'react';
export default class TimelineResumeSkills extends React.Component{

    getResumeBlock(data, index){

        return  <div data-v-2568b4c2="" className="section-skill" key={index}>
                    { data.names && <b data-v-2568b4c2="">{data.names}</b> }
                    { data.proficiency && <span data-v-2568b4c2="">{data.proficiency}</span> }
                </div>

    }

    render(){
        return  <div data-v-2568b4c2="" className="section">
                    <div data-v-2568b4c2="" className="section-headline">{this.props.title}</div>
                    <div data-v-2568b4c2="" className="section-item" >
                        {this.props.data.map((item, index) => {
                            return this.getResumeBlock(item, index);
                        })}
                    </div>
                </div>

    }
}